import React from "react";
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faPlus } from "@fortawesome/free-solid-svg-icons";
import * as ConfigTypes from 'config/ConfigTypes';
import "./FormInput.scss";

const FormInput = (props) => {
    const { el, label, name, required, error, hiddenStar, isChild = false, isOne = false,
        type = 'text', plus, addClasses, flexClasses, check, ...rest } = props;

    const fm = ({ id }) => props.intl.formatMessage({ id });

    const showPlus = () => {
        if (!flexClasses[plus]) {
            return (<div className="forminput-plus"
                onClick={() => addClasses({ [plus]: 'registerform-row' })} >
                <FontAwesomeIcon icon={faPlus} />
            </div>)
        }
    }

    return (
        <>
            {(check && check.intl) && <div className="forminput-check">
                <label /><span>{fm({ id: check.intl })}</span>
            </div>}
            <div className="forminput-formgroup">
                {label && (
                    <label className={(isChild && !isOne) ? 'forminput-xs' : null}>
                        {label}
                        <span>
                            {(required && !hiddenStar) && <FontAwesomeIcon icon={faStar} />}
                        </span>
                    </label>)}
                <div className="forminput-required">
                    {/* {(required && !hiddenStar) && < FontAwesomeIcon icon={faStar} />} */}
                </div>
                <input className={`forminput ${error ? 'forminput-error' : ''}`}
                    type={type} {...rest} />
                {plus && showPlus()}
            </div>
            {(error && error !== ConfigTypes.EMPTY) && <div className="forminput-msg">{error}</div>}
            {(el && el.appendObj && el.appendObj.intl) && <div className="forminput-append">{fm({ id: el.appendObj.intl })}</div>}
        </>
    )
}

export default injectIntl(FormInput);